module.exports = __webpack_public_path__ + "static/gallery_04-5359cd900134d8f52ac20647b370a8bb.jpg";